import { ItemList } from "../../orm";

// Store totals outside of ORM state
let salesTotals = {
  total_photographer_amount: 0,
  total_revenue: 0,
};

class AdminSalesList extends ItemList {

  getEntityKey() {
    return "admin/sales";
  }

  fixResponse(json) {
    // API returns { results: [...], totals: {...} }
    // Store totals and return just the results array for ORM
    if (json && json.totals) {
      salesTotals = json.totals;
    }
    return json && json.results ? json.results : json;
  }

  getTotals() {
    return salesTotals;
  }

}

export const adminSalesList = new AdminSalesList("admin_sales__default");
